"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomSlider } from "@/components/ui/custom-slider";
interface DynamicAreaSectionProps {
  value: number;
  onChange: (value: number) => void;
}
const areaSteps = [1000, 2000, 3000, 4000, 5000, 6000, 7000];
export function DynamicAreaSection(t0) {
  const $ = _c(16);
  const {
    value,
    onChange
  } = t0;
  const findClosestIndex = _temp;
  let t1;
  if ($[0] !== value) {
    t1 = findClosestIndex(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentSliderIndex = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = newIndex => {
      onChange(areaSteps[newIndex]);
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSliderChange = t2;
  let t3;
  if ($[4] !== handleSliderChange) {
    t3 = newIndex_0 => handleSliderChange(newIndex_0 as number);
    $[4] = handleSliderChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentSliderIndex || $[7] !== t3) {
    t4 = <div className="relative h-6 flex items-center px-3"><CustomSlider value={currentSliderIndex} onChange={t3} min={0} max={areaSteps.length - 1} step={1} ariaLabel="Minimum Area" rangeClassName="absolute bg-gray-600 rounded-full h-full" /></div>;
    $[6] = currentSliderIndex;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== currentSliderIndex) {
    t5 = areaSteps.map((step_0, idx_0) => {
      const isSelected = idx_0 === currentSliderIndex;
      return <div key={step_0} className="flex flex-col items-center gap-1" style={{
        minWidth: 36,
        paddingLeft: idx_0 === 0 ? 0 : 0,
        paddingRight: idx_0 === areaSteps.length - 1 ? 2 : 0
      }}><div className={`w-px h-2 ${isSelected ? "bg-primary-600" : "bg-gray-400"}`} /><span className={`text-xs font-semibold ${isSelected ? "text-primary-600" : "text-gray-600"}`} style={{
          padding: "0 2px"
        }}>{step_0}+</span></div>;
    });
    $[9] = currentSliderIndex;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="flex justify-between text-xs text-gray-600 select-none pointer-events-none mb-2 px-3">{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className="space-y-6"><div className="space-y-4">{t4}{t6}</div></div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(val) {
  let closest = 0;
  let minDiff = Infinity;
  areaSteps.forEach((step, idx) => {
    const diff = Math.abs(step - val);
    if (diff < minDiff) {
      minDiff = diff;
      closest = idx;
    }
  });
  return closest;
}